import { useMutation } from '@apollo/client';
import UPDATE_USER_CONTENT_SHARE from 'graphql/mutations/userContentShares/UpdateUserContentShare.graphql';

export default function useUpdateUserContentShareMutation() {
  return useMutation(UPDATE_USER_CONTENT_SHARE);
}
